import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';

import { EndpointsConstants } from '../constants-v2';
import { CashDocument } from '@cemex-core/types-v2/dist/invoices-payments';

import { HttpCemex } from '../http.service';

@Injectable()
export class CashSalesService {
  private apiCashDocuments: string;

  constructor(
    private http: HttpCemex,
    private endpoints: EndpointsConstants,
  ) {
    // TODO: MOVE TO PATH CONSTANTS
    this.apiCashDocuments = 'cashdocuments';
  }

  public getCreditDocs(companyCode: string, customerCode: string, jobSiteCode: string): Promise<CashDocument[]> {
    const apiQuery = `companyCode=${companyCode}&customerCode=${customerCode}&jobSiteCode=${jobSiteCode}`;
    const endpoint = `${this.apiCashDocuments}?${apiQuery}`;
    return this.http
      .get(this.getUrl(endpoint))
      .pipe(
        map((response: any) => {
          const aux: CashDocument[] = response;
          return this.handleCashDocumentsData(aux);
        }),
      )
      .toPromise()
      .then((data) => data)
      .catch((error) => error);
  }

  private handleCashDocumentsData(aux: CashDocument[]): CashDocument[] {
    aux.forEach((document, i) => {
      document.index = i;
      document.flagInvalidAmnt = false;
      document.errMsg = '';
      document.toCommit = 0;
      // document.createDate = '2017-01-01T00:00:00';
      if (document.createDate) {
        const d1 = document.createDate.split('T')[0].split('-');
        const d2 = document.createDate.split('T')[1];
        document.createDate = d1[2] + '-' + d1[1] + '-' + d1[0] + 'T' + d2;
        // document.createDate = this.getDateObject(document.createDate).toString();
      }
      document.amount = !document.amount ? 0 : document.amount;
      document.reconciledAmount = !document.reconciledAmount ? 0 : document.reconciledAmount;
      document.commitedAmount = !document.commitedAmount ? 0 : document.commitedAmount;
    });
    return aux;
  }

  private getUrl(api: string): string {
    const url = this.http.generateEndpoint(this.endpoints.V1 + this.endpoints.peCapability + api);
    return url;
  }
}
